import TeamManagement from './TeamManagement';

export default TeamManagement;
